import '../social_content_context_view.js.coffee'
Monitoring.Views ||= {}

class Monitoring.Views.GoogleMyBusinessContentContextView extends Monitoring.Views.SocialContentContextView

  newSearch: =>
    contextClasses = []
    if @rootParentId != @socialContent.numeric_id()
      contextClasses.push Monitoring.Views.GoogleMyBusinessContentPreviousCommentsView
    contextClasses.push Monitoring.Views.GoogleMyBusinessContentFollowingCommentsView

    _.each(contextClasses, (contextClass) =>
      new contextClass({el: @$el, socialContent: @socialContent}).fetch()
    )
    @show()
